import { GetServerSideProps, NextPage } from 'next'
import { readToken } from '../../../../lib/sanity.api'
import { getClient, getProductBySlug } from '../../../../lib/sanity.client'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { Product } from '../../../../components/product/Product'

interface ProductProps {
  product: Product
}

const ProductPage: NextPage<ProductProps> = ({ product }: ProductProps) => {
  return <Product product={product} />
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { params, preview, locale } = context
  const { product: productSlug } = params
  const client = getClient(preview ? { token: readToken } : undefined)

  const [product, translations] = await Promise.all([
    getProductBySlug(locale as AppLocale, client, productSlug as string),
    serverSideTranslations(locale, ['common']),
  ])

  if (!product) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      ...translations,
      product,
    },
  }
}

export default ProductPage
